export type {
  TableColumn,
  TableProps,
} from "@components/contracts/Table.types";
export { CelebrationTable } from "./Table.adapter";
